<template>
    <v-card>
        <v-toolbar v-if="!this.clockOutView" color="primary" dark>
            <v-toolbar-title class="dialog-toolbar"> Employee</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-else color="error" dark>
            <v-toolbar-title class="dialog-toolbar">
                Employee: {{ this.clockInDetails.Name }}
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!this.clockOutView">
            <form autocomplete="on" onsubmit="return false">
                <v-row>
                    <v-col>
                        <v-responsive class="ma-auto" max-width="512">
                            <v-text-field
                                v-model="clockInEmpID"
                                label="User ID"
                                variant="outlined"
                                hint="Enter your employee ID and press next to clock in"
                                persistent-hint
                                class="custom-height mt-2"
                                clearable
                                :error-messages="errorMsg"
                                @input="clearError"
                                @click:clear="onClearClicked_ID"
                                type="text"
                                name="clockInEmpID"
                            >
                            </v-text-field>
                        </v-responsive>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-btn
                        color="error"
                        @click="closeEmployeePunchScreen"
                        class="custom-large-btn mr-10"
                        style="width: 10%"
                        variant="elevated"
                    >
                        <span class="button-text">Exit</span>
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="checkActivity"
                        size="x-large"
                        class="custom-large-btn ml-10"
                        style="width: 10%"
                        variant="elevated"
                        :disabled="disableClockIn"
                        :loading="loading"
                    >
                        <span class="button-text">Next</span>
                    </v-btn>
                </v-row>
            </form>
        </v-card-text>
        <v-card-text v-else>
            <QuantityEntry
                :punchName="clockInDetails.Name"
                :jobInfo="jobInfo"
                :punchID="clockInEmpID"
                @clockOutDetails="getClockOutDetails"
                @clockOutJob="clockOutJob"
                @closeEmployeePunchScreen="closeEmployeePunchScreen"
            >
            </QuantityEntry>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";
import QuantityEntry from "./QuantityEntry.vue";

export default {
    name: "ClockIn",
    emits: [
        "closeEmployeePunchScreen",
        "clockInJob",
        "clockInDetails",
        "clockOutJob",
        "clockOutDetails",
    ],
    components: { QuantityEntry },
    props: {
        jobInfo: {
            type: Object,
            default: null,
        },
        punchInOut: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            clockInEmpID: "",
            clockOutView: false,
            loading: false,
            clockInDetails: [],
            clockOutDetails: [],
            errorMsg: [],
            scrapReasons: [
                { text: "", value: "" },
                { text: "Assembly Scrap", value: "ASM" },
                { text: "CNC Scrap", value: "CNC" },
                { text: "Purchased Parts Scrap", value: "PUR" },
                { text: "Silkscreen Scrap", value: "SIL" },
            ],
            jobDtl: [
                { header: "Job Number", info: this.jobInfo.JobNum },
                { header: "Assembly Seq", info: this.jobInfo.AsmSeq },
                { header: "Operation Seq", info: this.jobInfo.OprSeq },
            ],
            machine_id: null,
        };
    },
    watch: {
        clockInEmpID(newVal) {
            if (newVal === null || newVal === "") {
                this.errorMsg.push("Please Enter An Employee ID");
            }
        },
    },
    computed: {
        disableClockIn() {
            if (this.clockInEmpID === "" || this.clockInEmpID === null) {
                return true;
            }
            return false;
        },
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },

        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
    },
    methods: {
        async checkActivity() {
            this.loading = true;
            try {
                await axios
                    .get(
                        route("legacy-api.getSpecificTablet", {
                            tabletId: this.resourceId,
                        })
                    )
                    .then((response) => {
                        this.machine_id = response.data.data;
                    });
            } catch (err) {
                console.log(err);
            }
            //// need to wait to the top call
            switch (this.deptTitle) {
                case "CNC":
                    try {
                        await axios
                            .get(
                                route("legacy-api.checkEmployeeActivity", {
                                    EmpID: this.clockInEmpID.toUpperCase(),
                                    ResourceID: this.machine_id,
                                    JobNum: this.jobInfo.JobNum,
                                    AsmSeq: this.jobInfo.AsmSeq,
                                    OprSeq: this.jobInfo.OprSeq,
                                })
                            )
                            .then((response) => {
                                this.clockInDetails = response.data;
                                if (
                                    this.clockInDetails.Error === 0 &&
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.sendClockInDetails();
                                    this.closeEmployeePunchScreen();
                                    this.clockInJob();
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.clockOutView = true;
                                }
                                if (this.clockInDetails.Error !== 0) {
                                    this.errorMsg.push(
                                        this.clockInDetails.Error
                                    );
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is already clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") ya registró su entrada en este trabajo"
                                    );
                                }
                                if (
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is not clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") no está registrado en este trabajo"
                                    );
                                }
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "ASM":
                    try {
                        await axios
                            .get(
                                route("legacy-api.checkEmployeeActivity", {
                                    EmpID: this.clockInEmpID.toUpperCase(),
                                    ResourceID: this.resourceId,
                                    JobNum: this.jobInfo.JobNum,
                                    AsmSeq: this.jobInfo.AsmSeq,
                                    OprSeq: this.jobInfo.OprSeq,
                                })
                            )
                            .then((response) => {
                                this.clockInDetails = response.data;
                                if (
                                    this.clockInDetails.Error === 0 &&
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.sendClockInDetails();
                                    this.closeEmployeePunchScreen();
                                    this.clockInJob();
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.clockOutView = true;
                                }
                                if (this.clockInDetails.Error !== 0) {
                                    this.errorMsg.push(
                                        this.clockInDetails.Error
                                    );
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is already clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") ya registró su entrada en este trabajo"
                                    );
                                }
                                if (
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is not clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") no está registrado en este trabajo"
                                    );
                                }
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SIL":
                    try {
                        await axios
                            .get(
                                route("legacy-api.checkEmployeeActivity", {
                                    EmpID: this.clockInEmpID.toUpperCase(),
                                    ResourceID: this.machine_id,
                                    JobNum: this.jobInfo.JobNum,
                                    AsmSeq: this.jobInfo.AsmSeq,
                                    OprSeq: this.jobInfo.OprSeq,
                                })
                            )
                            .then((response) => {
                                this.clockInDetails = response.data;
                                if (
                                    this.clockInDetails.Error === 0 &&
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.sendClockInDetails();
                                    this.closeEmployeePunchScreen();
                                    this.clockInJob();
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.clockOutView = true;
                                }
                                if (this.clockInDetails.Error !== 0) {
                                    this.errorMsg.push(
                                        this.clockInDetails.Error
                                    );
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is already clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") ya registró su entrada en este trabajo"
                                    );
                                }
                                if (
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is not clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") no está registrado en este trabajo"
                                    );
                                }
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SAW":
                    try {
                        await axios
                            .get(
                                route("legacy-api.checkEmployeeActivity", {
                                    EmpID: this.clockInEmpID.toUpperCase(),
                                    ResourceID: this.machine_id,
                                    JobNum: this.jobInfo.JobNum,
                                    AsmSeq: this.jobInfo.AsmSeq,
                                    OprSeq: this.jobInfo.OprSeq,
                                })
                            )
                            .then((response) => {
                                this.clockInDetails = response.data;
                                if (
                                    this.clockInDetails.Error === 0 &&
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.sendClockInDetails();
                                    this.closeEmployeePunchScreen();
                                    this.clockInJob();
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.clockOutView = true;
                                }
                                if (this.clockInDetails.Error !== 0) {
                                    this.errorMsg.push(
                                        this.clockInDetails.Error
                                    );
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is already clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") ya registró su entrada en este trabajo"
                                    );
                                }
                                if (
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is not clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") no está registrado en este trabajo"
                                    );
                                }
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "VACF":
                    try {
                        await axios
                            .get(
                                route("legacy-api.checkEmployeeActivity", {
                                    EmpID: this.clockInEmpID.toUpperCase(),
                                    ResourceID: this.machine_id,
                                    JobNum: this.jobInfo.JobNum,
                                    AsmSeq: this.jobInfo.AsmSeq,
                                    OprSeq: this.jobInfo.OprSeq,
                                })
                            )
                            .then((response) => {
                                this.clockInDetails = response.data;
                                if (
                                    this.clockInDetails.Error === 0 &&
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.sendClockInDetails();
                                    this.closeEmployeePunchScreen();
                                    this.clockInJob();
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.clockOutView = true;
                                }
                                if (this.clockInDetails.Error !== 0) {
                                    this.errorMsg.push(
                                        this.clockInDetails.Error
                                    );
                                }
                                if (
                                    this.clockInDetails.Active &&
                                    this.punchInOut === "in"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is already clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") ya registró su entrada en este trabajo"
                                    );
                                }
                                if (
                                    !this.clockInDetails.Active &&
                                    this.punchInOut === "out"
                                ) {
                                    this.errorMsg.push(
                                        "User (" +
                                            this.clockInDetails.Name +
                                            ") is not clocked in on this job / Usuario (" +
                                            this.clockInDetails.Name +
                                            ") no está registrado en este trabajo"
                                    );
                                }
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
            }

            this.loading = false;
        },
        onClearClicked_ID() {
            this.clockInEmpID = "";
        },
        clearError() {
            this.errorMsg = [];
        },
        clockInJob() {
            this.$emit("clockInJob");
        },
        clockOutJob() {
            this.$emit("clockOutJob");
        },
        closeEmployeePunchScreen() {
            this.$emit("closeEmployeePunchScreen");
        },
        sendClockInDetails() {
            this.clockInDetails.EmployeeNum = this.clockInEmpID;
            this.$emit("clockInDetails", this.clockInDetails);
        },
        getClockOutDetails(dtl) {
            this.clockOutDetails = dtl;
            this.sendClockOutDetails();
        },
        sendClockOutDetails() {
            this.$emit("clockOutDetails", this.clockOutDetails);
        },
    },
};
</script>

<style scoped>
.dialog-toolbar {
    font-size: 2em;
    line-height: 1.2;
}

.custom-large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    padding: 60px 60px;
    width: 10%;
}

.button-text {
    display: inline-block;
}

.custom-height {
    height: 20vh;
}

:deep(.v-input__details) {
    align-items: flex-start;
}
</style>
